export default "__VITE_ASSET__ib1XjrGT__"